import React, { useState, useRef } from "react";

export default function OrgLogoUploader({ org, token, API_BASE_URL }) {
  const [logoUploading, setLogoUploading] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const [logoUrl, setLogoUrl] = useState(`${API_BASE_URL}/org/get-org-logo/${org.orgId}`);
  const fileInputRef = useRef(null);

  const handleLogoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    // Restrict to PNG and JPEG
    if (!['image/png', 'image/jpeg'].includes(file.type)) {
        setLogoError('Only PNG and JPEG images are allowed.');
        return;
    }
    setLogoError('');
    setLogoUploading(true);
    try {
        const formData = new FormData();
        formData.append('orgId', org.orgId);
        formData.append('logo', file);
        const response = await fetch(`${API_BASE_URL}/org/upload-org-logo`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: formData,
        });
        const result = await response.json();
        if (result.success) {
            // Refresh logo by updating logoUrl (add timestamp to force reload)
            setLogoUrl(`${API_BASE_URL}/org/get-org-logo/${org.orgId}?t=${Date.now()}`);
        } else {
        setLogoError('Failed to upload logo.');
        }
    } catch (err) {
        setLogoError('Failed to upload logo.');
    }
    setLogoUploading(false);
    };

  return (
    <div style={{ display: "flex", alignItems: "left" }}>
      {logoError ? (
        <div style={{ height: 48, width: 48, background: '#eee', borderRadius: 8 }} />
    ) : (
        <img
        src={logoUrl}
        alt="Organization Logo"
        style={{ height: 48, maxHeight: 48, objectFit: 'contain', borderRadius: 8 }}
        onError={() => setLogoError(true)}
        />
    )}
      <button
        type="button"
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
        disabled={logoUploading}
        style={{ marginLeft: 8 }}
      >
        {logoUploading ? "Uploading..." : "Change Logo"}
      </button>
        <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept="image/png, image/jpeg"
            onChange={handleLogoUpload}
        />
    </div>
  );
}